import { all, call, takeEvery, fork } from "redux-saga/effects";
import newRequestFunction from "../Utils/newSGF"

import {
  CREATE_IN_CAMP_TRAINING,
  UPDATE_IN_CAMP_TRAINING,
} from "../ActionTypes";

import {
  createInCampTrainingSuccess,
  createInCampTrainingFailure,

  updateInCampTrainingSuccess,
  updateInCampTrainingFailure,
} from "../Actions"

import {
  createInCampTrainingApi,
  updateInCampTrainingApi
} from "../Api";



// Requests
const createInCampTrainingRequest = function* ({ payload }) {
  yield call(newRequestFunction, createInCampTrainingSuccess, createInCampTrainingFailure, createInCampTrainingApi, payload)
}

const updateInCampTrainingRequest = function* ({ payload }) {
  yield call(newRequestFunction, updateInCampTrainingSuccess, updateInCampTrainingFailure, updateInCampTrainingApi, payload)
}


// Watchers
const createInCampTrainingWatcher = function* () {
  yield takeEvery(CREATE_IN_CAMP_TRAINING, createInCampTrainingRequest)
}

const updateInCampTrainingWatcher = function* () {
  yield takeEvery(UPDATE_IN_CAMP_TRAINING, updateInCampTrainingRequest)
}

export default function* rootSaga() {
  yield all([
    fork(createInCampTrainingWatcher),
    fork(updateInCampTrainingWatcher),
  ])
}